import React from 'react';
import {Link} from 'react-router-dom';

export const SelectLense = ({ onToggle }) => {
	return (
		<>
			<div className="md:flex grid grid-cols-1 justify-center gap-4">
				<Link onClick={() => onToggle(2.1)} to="" className="lg:w-2/5 md:w-6/12 border-white border-2 hover:border-cyan-500 rounded-xl overflow-hidden">
					<div className="text-center bg-gradient-to-b from-sky-600 to-sky-700 p-5 text-white">
						<img src="images/thin-bluecut.png" alt="Blue Cut" className="w-2/6 inline-block"/>
						<div className="my-3 font-light text-sm">Frame + Lens <span className="font-medium text-xl">$198</span></div>
						<div className="warrenty text-xs text-yellow-500">1 Year Warranty</div>
						<button className="bg-cyan-500 rounded py-1 mt-3 px-8 font-light uppercase text-sm tracking-widest">Select Lense</button>
					</div>
					<div className="text-center">
						<ul className="specs-list text-sm">
							<li className="offer">Extra 25% Off. Coupon: S25</li>
							<li>Blocks blue light from digital devices</li>
							<li>Thin Lens (1.6 - 1.67 Index)</li>
							<li>Anti-Glare on both side of lens</li>
							<li>Scratch & Smudge Resistant</li>
							<li>Water & Dust Repellent</li>
							<li>UV 400 - Protection</li>
						</ul>
					</div>
				</Link>

				<Link onClick={() => onToggle(3)} to="" className="lg:w-2/5 md:w-6/12 md:mt-0 mt-10 border-white border-2 hover:border-cyan-500 rounded-xl overflow-hidden">
					<div className="text-center bg-gray-200 p-5 text-white">
						<h2 className="text-xl text-gray-700">Premium Anti-Glare</h2>
						<div className="my-3 font-light text-sm text-gray-500">Frame + Lens <br/><span className="font-medium text-xl text-cyan-500">$98</span></div>
						<div className="warrenty text-xs text-gray-500 none">1 Year Warranty</div>
						<button className="bg-cyan-500 rounded py-1 mt-3 px-8 font-light uppercase text-sm tracking-widest">Select Lense</button>
					</div>
					<div className="text-center">
						<ul className="specs-list text-sm">
							<li className="offer">Extra 25% Off. Coupon: S25</li>
							<li>
								<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-5 h-5 inline-block">
									<path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
								</svg>
							</li>
							<li>Thin Lens (1.6 Index)</li>
							<li>Anti-Glare on both side of lens</li>
							<li>Scratch & Smudge Resistant</li>
							<li>
								<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-5 h-5 inline-block">
									<path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
								</svg>
							</li>
							<li>UV 400 - Protection</li>
						</ul>
					</div>
				</Link>

			</div>
		</>
	)
}